import React from 'react';

const IconShell = ({ ...styles }) => (
  <svg viewBox="0 0 18 40" xmlns="http://www.w3.org/2000/svg" {...styles}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M17.607 15.953c-2.1-9.267-6.484-11.735-7.596-13.479C9.406 1.525 8.79.084 8.79.084c-.06.821-.167 1.342-.869 1.966C6.517 3.302.548 8.166.047 18.696c-.468 9.817 7.214 15.872 8.235 16.498.78.383 1.735.007 2.192-.345 3.702-2.542 8.767-9.321 7.129-18.896"
        fill="#10AA50"
      />
      <path
        d="M9.108 29.964c-.193 2.431-.332 3.846-.822 5.232 0 0 .323 2.314.548 4.765h.8c.192-1.727.484-3.44.875-5.133-1.038-.508-1.362-2.731-1.401-4.864z"
        fill="#B8C4C2"
      />
      <path
        d="M10.508 34.83c-1.049-.484-1.352-2.751-1.398-4.866.258-3.485.333-6.982.223-10.475-.054-1.833.028-16.98-.45-19.197.193.434.66 1.453 1.128 2.181 1.117 1.745 5.497 4.213 7.595 13.48 1.636 9.551-3.399 16.318-7.098 18.877z"
        fill="#12924F"
      />
    </g>
  </svg>
);

export default IconShell;
